import { render } from "./MedicalRecord.vue?vue&type=template&id=01db638a&scoped=true&ts=true"
import script from "./MedicalRecord.vue?vue&type=script&lang=ts"
export * from "./MedicalRecord.vue?vue&type=script&lang=ts"

import "./MedicalRecord.vue?vue&type=style&index=0&id=01db638a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01db638a"]])

export default __exports__